import React, { Fragment } from 'react'
import View from '../../Components/View/View'
import Footer from '../../Components/Footer/Footer'
import Navbar from '../../Components/Navbar/Navbar'


function ViewPage() {
  return (
    <Fragment>
      <Navbar/>
      <View/>
      <Footer/>
    </Fragment>
  )
}

export default ViewPage
